var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PolmedSpinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.value || _vm.preserveSpace),expression:"value || preserveSpace"}],style:(_vm.styles)})}
var staticRenderFns = []

export { render, staticRenderFns }